import React, { useState, useEffect } from "react";

import { Drawer, Button, Input } from "antd";

import "./SpecialInstructionDrawer.css";

const SpecialInstructionDrawer = ({
  open,
  onClose,
  onSave,
  initialValue = "",
}) => {
  const [instruction, setInstruction] = useState(initialValue);
  const textAreaRow = 11;
  useEffect(() => {
    setInstruction(initialValue);
  }, [initialValue]);

  const handleSave = () => {
    onSave(instruction);
    onClose();
  };

  const handleClose = () => {
    setInstruction(initialValue);
    onClose();
  };

  return (
    <Drawer
      title="Special Instruction"
      placement="bottom"
      rootClassName="SpecialInstructionDrawer"
      onClose={handleClose}
      open={open}
      closable={false}
      closeIcon={null}
      footer={(
        <div className="special-instruction-drawer-buttons">
          <Button type="default" htmlType="button" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="primary" htmlType="button" onClick={handleSave}>
            Save
          </Button>
        </div>
      )}
    >
      <Input.TextArea
        autoSize={{ minRows: textAreaRow, maxRows: textAreaRow }}
        value={instruction}
        onChange={(e) => setInstruction(e.target.value)}
        placeholder="Enter special instructions here..."
        className="SpecialInstructionDrawer__TextArea"
      />
    </Drawer>
  );
};

export default SpecialInstructionDrawer;
